import { Skeleton } from '@mui/material';

export default function AnimeCardSkeleton() {
  return (
    <Skeleton
      sx={{
        borderRadius: 4,
        width: '100%',
        aspectRatio: '7/10',
        //boxShadow: (t) => t.shadows[7],
        transform: "unset"
      }}
    />
  );
}